import {Component, Input, OnInit} from '@angular/core';

import {Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {User} from '../../../admin/models/user';
import {AuthorizationService} from '../../../../services/authorization.service';
import {AuthService} from '../../../../services/auth.service';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    user: User;
    @Input('right_sidenav') right_sidenav;


    constructor(private auth: AuthService,
                private authorization: AuthorizationService
        , private router: Router, private dialog: MatDialog) {

        this.user = new User();
    }

    ngOnInit() {
        this.user = this.authorization.getCurrentlyLoggedUser();
    }

    onLogout() {

        this.auth.setToken(null);
        this.auth.isLogged = false;
        localStorage.setItem('p', null);
        localStorage.setItem('current_user_id', null);
        localStorage.setItem('current_user', null);
        this.router.navigateByUrl('/admin/login');

    }



}
